import styled from 'styled-components';

const DialogTitle = styled.h3`
    color: rgba(0, 0, 0, 0.8);
    font-size: 1.2em;
    font-weight: bold;
    margin: 0;
    padding: 0;
`;

export const SpacedDialogTitle = styled(DialogTitle)`
    margin-bottom: 1em;
`;

export default DialogTitle;
